export default class ClearSnippetRevisionsStore {
  constructor(context) {
    this.context = context;
  }

  run() {
    this.context.stores.snippetRevisions.set([]);
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/knowledge_base/clear_snippet_revisions_store.js